import React, { useContext, useState } from 'react';

const DiscountModalContext = React.createContext({
  showModal: false,
  setShowModal: () => {},
  generatedDiscountCode: '',
  setGeneratedDiscountCode: () => {},
  discountCodes: [],
  setDiscountCode: () => {},
  discountCodeDropdown: null,
  setDiscountCodeDropdown: () => {},
  disableSubmitButton: false,
  setDisableSubmitButton: () => {},
  selectedTemplate: null,
  setSelectedTemplate: () => {},
  showErrorModal: false,
  setShowErrorModal: () => {},
  isEditingCode: false,
  setIsEditingCode: () => {},
  selectedDiscountCode: '',
  setSelectedDiscountCode: () => {},
  disableValue: false,
  setDisableValue: () => {},
  dynamicDiscountCreated: false,
  setDynamicDiscountCreated: () => {},
  dynamicDiscountDeleted: false,
  setDynamicDiscountDeleted: () => {},
  couponCode: '',
  setCouponCode: () => {},
  newCouponCode: '',
  setNewCouponCode: () => {},
  discountValue: '',
  setDiscountValue: () => {},
  discountType: 'percentage',
  setDiscountType: () => {},
  errorMessage: '',
  setErrorMessage: () => {},
  newCouponCodeValue: '',
  setNewCouponCodeValue: () => {},
  newCouponCodeType: '',
  setNewCouponCodeType: () => {},
  minPurchaseAmount: null,
  setMinimumPurchaseAmount: () => {},
  minQuantity: null,
  setMinQuantity: () => {},
  isFreeShipping: false,
  setIsFreeShipping: () => {},
  newCustomerOnly: false,
  setNewCustomerOnly: () => {},
  selectedTab: 'tab1',
  setSelectedTab: () => {},
  handleSelectCode: () => {},
  partnershipLimitModal: false,
  setPartnershipLimitModal: () => {},
  isDynamicDiscount: false,
  setIsDynamicDiscount: () => {},
});

const DiscountModalContentProvider = ({ children }) => {
  const [showModal, setShowModal] = useState(false);
  const [generatedDiscountCode, setGeneratedDiscountCode] = useState('');
  const [discountCodes, setDiscountCode] = useState([]);

  const [discountCodeDropdown, setDiscountCodeDropdown] = useState(null);
  const [disableSubmitButton, setDisableSubmitButton] = useState(false);

  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [showErrorModal, setShowErrorModal] = useState(false);

  const [isEditingCode, setIsEditingCode] = useState(false);
  const [selectedDiscountCode, setSelectedDiscountCode] = useState('');
  const [disableValue, setDisableValue] = useState(false);

  const [dynamicDiscountCreated, setDynamicDiscountCreated] = useState(false);
  const [dynamicDiscountDeleted, setDynamicDiscountDeleted] = useState(false);
  const [couponCode, setCouponCode] = useState('');
  const [newCouponCode, setNewCouponCode] = useState('');
  const [discountValue, setDiscountValue] = useState('');
  const [discountType, setDiscountType] = useState('percentage');
  const [errorMessage, setErrorMessage] = useState('');
  const [newCouponCodeValue, setNewCouponCodeValue] = useState('');
  const [newCouponCodeType, setNewCouponCodeType] = useState('');
  const [minPurchaseAmount, setMinimumPurchaseAmount] = useState(null);
  const [minQuantity, setMinQuantity] = useState(null);
  const [isFreeShipping, setIsFreeShipping] = useState(false);
  const [newCustomerOnly, setNewCustomerOnly] = useState(false);
  const [selectedTab, setSelectedTab] = useState('tab1');
  const [partnershipLimitModal, setPartnershipLimitModal] = useState(false);
  const [isDynamicDiscount, setIsDynamicDiscount] = useState(false);

  const handleSelectCode = (couponCode) => {
    setIsDynamicDiscount(false);
    setCouponCode(couponCode?.code);
    setNewCouponCode(couponCode?.code);
    setDiscountValue(couponCode?.discount_value);
    setNewCouponCodeValue(parseInt(couponCode?.discount_value));
    setDiscountType(couponCode?.discount_type);
    setNewCouponCodeType(couponCode?.discount_type);
    if (couponCode?.discount_type === 'free_shipping') {
      setDisableValue(true);
      setNewCouponCodeValue('');
    }
  };

  return (
    <DiscountModalContext.Provider
      value={{
        showModal,
        setShowModal,
        generatedDiscountCode,
        setGeneratedDiscountCode,
        discountCodes,
        setDiscountCode,
        discountCodeDropdown,
        setDiscountCodeDropdown,
        disableSubmitButton,
        setDisableSubmitButton,
        selectedTemplate,
        setSelectedTemplate,
        showErrorModal,
        setShowErrorModal,
        isEditingCode,
        setIsEditingCode,
        selectedDiscountCode,
        setSelectedDiscountCode,
        disableValue,
        setDisableValue,
        dynamicDiscountCreated,
        setDynamicDiscountCreated,
        dynamicDiscountDeleted,
        setDynamicDiscountDeleted,
        couponCode,
        setCouponCode,
        newCouponCode,
        setNewCouponCode,
        discountValue,
        setDiscountValue,
        discountType,
        setDiscountType,
        errorMessage,
        setErrorMessage,
        newCouponCodeValue,
        setNewCouponCodeValue,
        newCouponCodeType,
        setNewCouponCodeType,
        minPurchaseAmount,
        setMinimumPurchaseAmount,
        minQuantity,
        setMinQuantity,
        isFreeShipping,
        setIsFreeShipping,
        newCustomerOnly,
        setNewCustomerOnly,
        selectedTab,
        setSelectedTab,
        handleSelectCode,
        partnershipLimitModal,
        setPartnershipLimitModal,
        isDynamicDiscount,
        setIsDynamicDiscount,
      }}>
      {children}
    </DiscountModalContext.Provider>
  );
};

export const useDiscountModal = () => {
  return useContext(DiscountModalContext);
};

export default DiscountModalContentProvider;
